import React from "react";
import { AR_MARKUP_VIEW, MARKUP_VIEW } from "../../constants/Constants";
import PrepareMarkupView from "./PrepareMarkupView";
import { useSelector } from "react-redux";
import clsx from "clsx";
import MarkupMenubar from "./MarkupMenubar";
import { MARKUP_MENU_TYPE } from "../../constants/MarkupConstants";

const Markup = () => {
    const { markupInprogress, markupLiveStream, arMarkupLiveStream, arMarkupToastMsgStatus } = useSelector((state) => state.markup);
    return (
        <>
            {(markupInprogress === MARKUP_VIEW.PREPARE_VIEW || arMarkupLiveStream === AR_MARKUP_VIEW.PREPARE_VIEW) && (
                <PrepareMarkupView
                    showPrepareView={markupInprogress === MARKUP_VIEW.PREPARE_VIEW || arMarkupLiveStream === AR_MARKUP_VIEW.PREPARE_VIEW}
                    type={markupInprogress === MARKUP_VIEW.PREPARE_VIEW ? "Markup" : "ARMarkup"}
                />
            )}
            <div
                className={clsx(
                    "annotation-modal",
                    (markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW ||
                        markupLiveStream ||
                        arMarkupLiveStream === AR_MARKUP_VIEW.START_MARKUP_VIEW) &&
                        "active"
                )}
                id='markup-annotation'
            >
                <div className='annotation-modal-content'>
                    <div className='annotation-modal-body'>
                        {arMarkupToastMsgStatus && (
                            <div className='ar-measurement-toast'>
                                <div className='ar-measurement-toast-in'>
                                    <span>{arMarkupToastMsgStatus}</span>
                                </div>
                            </div>
                        )}
                        <div className='annotation-canvas-box'>
                            <canvas style={{ display: "none" }} id='markup-outer-canvas'></canvas>
                        </div>
                    </div>
                    <div className='annotation-action-menu'>
                        <MarkupMenubar
                            fromMarkup={MARKUP_MENU_TYPE.MARKUP_ANNOTATION}
                            isARMarkup={arMarkupLiveStream === AR_MARKUP_VIEW.START_MARKUP_VIEW}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Markup;
